import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=1bf54031&scoped=true"
import script from "./MaterialList.vue?vue&type=script&lang=js"
export * from "./MaterialList.vue?vue&type=script&lang=js"
import style0 from "./MaterialList.vue?vue&type=style&index=0&id=1bf54031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf54031",
  null
  
)

export default component.exports